module.exports = __webpack_public_path__ + "img/lab4.338872d1.png";